/** Closing data access (spec §5, B1-B14). Paths sit under the `/periods` resource. */

import type { JsonFetch } from '../accounts/accounts.api';

export type { JsonFetch } from '../accounts/accounts.api';

export type ControlId =
  | 'B1'
  | 'B2'
  | 'B3'
  | 'B4'
  | 'B5'
  | 'B6'
  | 'B7'
  | 'B8'
  | 'B9'
  | 'B10'
  | 'B11'
  | 'B12'
  | 'B13'
  | 'B14';

export type ControlSeverity = 'block' | 'warning' | 'step skipped';

export type ControlStatus = 'passed' | 'failed' | 'skipped';

export interface I18nText {
  az: string;
  en: string;
  ru: string;
}

export interface ControlOutcome {
  id: ControlId;
  owner: string;
  severity: ControlSeverity;
  implemented: boolean;
  title: I18nText;
  status: ControlStatus;
  message: string;
  details?: Record<string, unknown>;
}

export interface ClosingSummary {
  total: number;
  passed: number;
  failed: number;
  skipped: number;
  blockingFailed: number;
}

export type PeriodStatus = 'open' | 'closing' | 'closed';

export interface ClosingPeriodRecord {
  id: string;
  orgId: string;
  year: number;
  month: number;
  status: PeriodStatus;
  closedAt: string | null;
  closedBy: string | null;
}

export interface ClosingReport {
  period: ClosingPeriodRecord;
  controls: ControlOutcome[];
  summary: ClosingSummary;
  canClose: boolean;
  checkedAt: string;
}

export async function loadClosing(fetchJson: JsonFetch, periodId: string): Promise<ClosingReport> {
  return fetchJson<ClosingReport>(`/periods/${encodeURIComponent(periodId)}/closing`);
}

export async function closePeriod(fetchJson: JsonFetch, periodId: string): Promise<ClosingReport> {
  return fetchJson<ClosingReport>(`/periods/${encodeURIComponent(periodId)}/close`, { method: 'POST' });
}

export async function reopenPeriod(
  fetchJson: JsonFetch,
  periodId: string,
  reason: string,
): Promise<ClosingPeriodRecord> {
  return fetchJson<ClosingPeriodRecord>(`/periods/${encodeURIComponent(periodId)}/reopen`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ reason }),
  });
}
